import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { isEmpty } from 'lodash';
import Markdown from 'markdown-to-jsx';

import styles from './style.module.scss';

export default function TomorrowsFocus({
  data,
  isLoading,
  checkInWith,
  celebrationCount,
  noDataAvailable
}) {
  return (
    <div className={styles.tomorrowsFocus}>
      <h2>⏰ Tomorrow&apos;s Focus</h2>

      {noDataAvailable && !isLoading && (
        <p className={styles.insightsText}>
          To see revisit suggestions, please generate insights.
        </p>
      )}

      {isLoading ? (
        <CircularProgress className={styles.loadingSpinner} />
      ) : (
        <>
          <div className={styles.focusSection}>
            <h3>Revisit:</h3>
            {isEmpty(data) && !noDataAvailable && (
              <p>All students are on track!</p>
            )}
            <ul>
              {data.map((item, idx) => (
                <li key={idx}>
                  <Markdown>{item}</Markdown>
                </li>
              ))}
            </ul>
          </div>

          {checkInWith.length > 0 && (
            <div className={styles.focusSection}>
              <h3>Check in with:</h3>
              <p>
                {checkInWith.join(', ')} - assess barriers to getting started
              </p>
            </div>
          )}

          {celebrationCount > 0 && (
            <div className={styles.focusSection}>
              <h3>Celebrations:</h3>
              <p>🎉 {celebrationCount} students mastered the concept!</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
